import {Directive, ElementRef, OnInit, Renderer2} from '@angular/core';

@Directive({
    selector: '[appInViewPort]'
})
export class InViewPortDirective implements OnInit {
  constructor(private readonly el: ElementRef, private readonly renderer: Renderer2) {}

  ngOnInit(): void {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          this.renderer.setStyle(this.el.nativeElement, 'opacity', '1');
        } else {
          this.renderer.setStyle(this.el.nativeElement, 'opacity', '0');
        }
      },
      { threshold: 0.1 } // Adjust threshold as needed
    );

    observer.observe(this.el.nativeElement);
  }
}
